import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationModels } from '@wz-models';
import { FilePathManagerComponent } from 'libs/modules/tunnelsante/components/insurances/file-manager/file-manager.component';
import { MentionsLegalesEtCguComponent } from 'libs/modules/tunnelsante/components/mentions-legales-et-cgu/mentions-legales-et-cgu.component';
import { ClientComponent } from 'libs/modules/tunnelsante/components/nps/client/client.component';
import { OpinionAComponent } from 'libs/modules/tunnelsante/components/nps/opinion-a/opinion-a.component';
import { OupsComponent } from 'libs/modules/tunnelsante/components/nps/oups/oups.component';
import { ProspectComponent } from 'libs/modules/tunnelsante/components/nps/prospect/prospect.component';
import { RemerciementComponent } from 'libs/modules/tunnelsante/components/nps/remerciement/remerciement.component';
import { ReclamationsComponent } from 'libs/modules/tunnelsante/components/reclamations/reclamations.component';

export const routes: Routes = [
  //   {
  //     path: '',
  //     redirectTo: 'assurance-sante',
  //     pathMatch: 'full'
  //   },
  {
    path: 'fileMTX/getFiles',
    component: FilePathManagerComponent,
  },
  // {
  //   path: '',
  //   redirectTo: 'app/health-insurance',
  //   pathMatch: 'full'
  // },
  // {
  //   path: 'app/car-insurance',
  //   loadChildren: () => import('@wz-tunnel/car-insurance').then(m => m.CarInsuranceModule),
  //   canActivate: [TunnelAuthorizationGuard],
  //   data: {
  //     rights: [AuthenticationModels.RightEnum.AccessBrokerApp, AuthenticationModels.RightEnum.AutoProduct]
  //   }
  // },

  {
    path: '',
    //loadChildren: () => import('@wz-tunnel/health-insurance').then(m => m.HealthInsuranceModule),
    loadChildren: () =>
      import('@wz-tunnel/health-insurance-direct').then(
        (m) => m.HealthInsuranceModule,
      ),
    //canActivate: [TunnelAuthorizationGuard],
    data: {
      rights: [
        AuthenticationModels.RightEnum.AccessBrokerApp,
        AuthenticationModels.RightEnum.InfinityProduct,
      ],
    },
  },
  {
    path: 'donnez-votre-avis',
    component: ProspectComponent,
  },
  {
    path: 'donnez-votre-avis-client',
    component: ClientComponent,
  },
  {
    path: 'oops',
    component: OupsComponent,
  },
  {
    path: 'remerciements',
    component: RemerciementComponent,
  },
  {
    path: 'opinion-assurance',
    component: OpinionAComponent,
  },
  {
    path: 'mentions-legales-et-cgu',
    component: MentionsLegalesEtCguComponent,
  },
  {
    path: 'reclamations',
    component: ReclamationsComponent,
  },

  // {
  //   path: 'app/health-insurance',
  //   loadChildren: () => import('@wz-tunnel/health-insurance').then(m => m.HealthInsuranceModule),
  //   canActivate: [BrokerAuthorizationGuard],
  //   data: {
  //     rights: [AuthenticationModels.RightEnum.AccessBrokerApp]
  //   }
  // },

  //   {
  //     path: 'app/clients/:clientId/policies/:policyId/documents',
  //     component: PageSubscriptionComponent,
  //   },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppBrokerRoutingModule {}
